import * as yup from "yup";

export const refundSchema = (remainingAmount) => yup.object().shape({
    amount: yup.number().required().default(0).max(remainingAmount).label("Refund Amount"),
    reason: yup.string().required().default("").label("Reason")
});
